import axiosInstance from "../axiosInterceptor";

export async function getAllsubSubject() {
  const response = await axiosInstance.get(`/student/getAllSubSubject`);
  const data = response?.data;
  return data;
}
